import { createFileRoute } from '@tanstack/react-router';
import { EULA } from '@/components/legal';

// Public route - no auth required
export const Route = createFileRoute('/eula')({
  component: EULA,
});
